export const RedError = '#FF0000'
export const GreenSuccess = '#2D8630'
export const DarkVoyixPurple = '#5F259F'
export const LightVoyixPurple = '#B280FF'
